import { render, staticRenderFns } from "./forward-detail.vue?vue&type=template&id=4a8c4228&scoped=true&"
import script from "./forward-detail.vue?vue&type=script&lang=js&"
export * from "./forward-detail.vue?vue&type=script&lang=js&"
import style0 from "./forward-detail.vue?vue&type=style&index=0&id=4a8c4228&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c4228",
  null
  
)

export default component.exports